import blogsData from './blogs.json';

export interface ArticleItem {
  title: string;
  date: string;
  tag: string;
  image: string;
  content: Array<{ type: string; text?: string; src?: string; alt?: string }>;
  slug: string;
}

export interface BlogItem {
  id: string;
  sq: ArticleItem;
  en: ArticleItem;
  de: ArticleItem;
}

export const blogsRecord: Record<string, BlogItem> = blogsData as Record<string, BlogItem>;

export function normalizeSlugOrTitle(str: string): string {
  return decodeURIComponent(str || '')
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function findArticle(input: string): {
  id: string;
  data: BlogItem;
  matchedLang: 'sq' | 'en' | 'de';
  article: ArticleItem;
} | null {
  if (!input) return null;
  const decoded = decodeURIComponent(input).replace(/\/+$/, '').trim();
  const normalized = normalizeSlugOrTitle(decoded);

  for (const [id, data] of Object.entries(blogsRecord)) {
    if (id === decoded || normalizeSlugOrTitle(id) === normalized) {
      return {
        id,
        data,
        matchedLang: 'en',
        article: data.en || data.sq || data.de,
      };
    }
    for (const lang of ['sq', 'en', 'de'] as const) {
      const art = data[lang];
      if (!art) continue;
      if (art.slug === decoded || normalizeSlugOrTitle(art.slug) === normalized) {
        return { id, data, matchedLang: lang, article: art };
      }
      if (art.title === decoded || normalizeSlugOrTitle(art.title) === normalized) {
        return { id, data, matchedLang: lang, article: art };
      }
    }
  }
  return null;
}

export function getCanonicalArticlePath(id: string, lang: 'sq' | 'en' | 'de'): string {
  const item = blogsRecord[id];
  if (!item) return `/sq/artikujt/${id}`;
  const slug = item[lang]?.slug || item.en?.slug || id;
  if (lang === 'en') return `/en/articles/${slug}`;
  if (lang === 'de') return `/de/artikel/${slug}`;
  return `/sq/artikujt/${slug}`;
}

export function getCanonicalArticleUrl(
  id: string,
  lang: 'sq' | 'en' | 'de',
  baseUrl = 'https://www.vizionidigjital.com'
): string {
  return `${baseUrl}${getCanonicalArticlePath(id, lang)}`;
}

export function getArticleHreflangs(
  id: string,
  baseUrl = 'https://www.vizionidigjital.com'
): { lang: string; url: string }[] {
  const item = blogsRecord[id];
  if (!item) return [];
  return [
    { lang: 'sq', url: getCanonicalArticleUrl(id, 'sq', baseUrl) },
    { lang: 'en', url: getCanonicalArticleUrl(id, 'en', baseUrl) },
    { lang: 'de', url: getCanonicalArticleUrl(id, 'de', baseUrl) },
    { lang: 'x-default', url: getCanonicalArticleUrl(id, 'en', baseUrl) },
  ];
}
